<script>
  import { onMount, createEventDispatcher } from 'svelte'
  import Modal from './Modal.svelte'
  import Api from './services/Api.js'
  import { currentSheet, marketSheetItems } from './stores/root.js'

  const dispatch = createEventDispatcher()

  export let item, detailId
  let deleting = false

  async function handleDelete() {
    const itemId = item.itemId ? item.itemId : item.id

    const deleteItem = async (id) => {
      await Api.delete(`/items/${id}`)

      if ($currentSheet.items.length > 0) {
        currentSheet.update((sheet) => ({
          ...sheet,
          items: sheet.items.filter((item) => item.id !== id),
        }))
      }
    }

    const deleteDetail = async (id) => {
      await Api.delete(`/details/${id}`)
      if ($marketSheetItems.length > 0) {
        marketSheetItems.update((items) =>
          items.filter((item) => item.detailId !== id)
        )
      }
    }

    deleting = true

    if (detailId) {
      await deleteDetail(detailId)
      const detailCount = await Api.get(`/details/count?item=${itemId}`)
      if (detailCount.data == 0) await deleteItem(itemId)
    } else {
      for (const detail of item.details) {
        await deleteDetail(detail.id)
      }
      await deleteItem(itemId)
    }

    dispatch('delete')
  }

  onMount(async () => {})
</script>

<Modal fullScreen={false} on:close={(e) => dispatch('close')}>
  <div class="modal-header">
    <div class="fs-4 modal-title">Are you sure?</div>
    <button
      type="button"
      class="btn-close"
      data-bs-dismiss="modal"
      aria-label="Close"
    />
  </div>

  <div class="modal-body">
    This will delete <span class="fw-bold"
      >{item.itemName ? item.itemName : item.name}, {item.variationName}</span
    >
    {#if !detailId}
      from all market locations?
    {/if}
  </div>

  <div class="modal-footer">
    <button
      class="btn btn-secondary"
      data-bs-dismiss="modal"
      disabled={deleting}>Cancel</button
    >

    <button class="btn btn-danger" on:click={handleDelete}>
      {#if deleting}
        <div class="spinner-border spinner-border-sm text-light" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      {:else}
        Delete
      {/if}
    </button>
  </div>
</Modal>

<style>
  .btn-danger {
    min-width: 130px;
  }
</style>
